export default Object.freeze({
  baseURL: 'https://member.huntcontrol.com/api_react_token_v3',
  basePath: 'https://me.huntcontrol.com',
  // baseURL: 'http://localhost:8080/hunt-member/api_react_token_v3',
  // basePath: 'http://localhost:3000',
});
